/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Form } from '@organisms';

import LanguageSelect from '../LanguageSelect';

const LanguageField = ({ onChange, queryVariables, ...props }) => (
  <Form.Item {...props}>
    <LanguageSelect onChange={onChange} queryVariables={queryVariables} />
  </Form.Item>
);

export default LanguageField;
